var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFi3199725(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_4498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 3.75016C9.5413 3.75016 9.16797 3.37683 9.16797 2.91683V1.66683C9.16797 1.20683 9.5413 0.833496 10.0013 0.833496C10.4613 0.833496 10.8346 1.20683 10.8346 1.66683V2.91683C10.8346 3.37683 10.4613 3.75016 10.0013 3.75016Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8925 17.1283L17.4341 16.62C17 16.4683 16.77 15.9933 16.9216 15.5592C17.0733 15.125 17.5483 14.8958 17.9825 15.0467L19.4408 15.555C19.875 15.7067 20.105 16.1817 19.9533 16.6158C19.8016 17.0508 19.3258 17.28 18.8925 17.1283Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0466397 16.6158C-0.105027 16.1816 0.124973 15.7058 0.55914 15.555L2.01747 15.0466C2.45247 14.895 2.92664 15.125 3.07831 15.5591C3.22997 15.9933 2.99997 16.4691 2.56581 16.62L1.10747 17.1283C0.67414 17.28 0.198306 17.0508 0.0466397 16.6158Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 2.5L18.3346 5.83333L10.0013 9.16667L1.66797 5.83333L10.0013 2.5Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 10.6284L1.66797 7.62842V15.8334C1.66797 16.0076 1.7763 16.1643 1.94047 16.2243L9.16797 18.8868V10.6284Z",
    fill: "#5D616C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.832 10.6284V18.8868L18.0595 16.2243C18.2237 16.1643 18.332 16.0076 18.332 15.8334V7.62842L10.832 10.6284Z",
    fill: "#5D616C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_4498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi3199725);
export default __webpack_public_path__ + "static/media/fi_3199725.82718dfb0fe1046a9cfc7e91f352b933.svg";
export { ForwardRef as ReactComponent };